import type { EventKind } from '@/common/api/models/eventKind';
import { isFeatureFlagActive } from '@/common/hooks/useUserFeatures';

type FeatureFlags = Record<string, boolean> | undefined;

/**
 * Filter event kinds by deprecated status and optional required feature flag.
 * Keep the currently selected event kind visible so existing forms do not
 * render an empty select after a flag/deprecation change.
 */
export const filterVisibleEventKinds = (
  eventKinds: EventKind[],
  flags: FeatureFlags,
  selectedEventKindId?: string | null,
): EventKind[] => eventKinds.filter((kind) => {
  if (kind.id === selectedEventKindId) {
    return true;
  }
  if (kind.deprecated) {
    return false;
  }
  return !kind.requiredFeatureFlag
    || isFeatureFlagActive(flags, kind.requiredFeatureFlag);
});
